/**
 * ftp服务器配置api接口
 * @author： xuyd
 * @date：2022-01-12
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 列表检索
   * @param params
   */
  searchVarList: (params) => {
    return request.post(serviceModule + "/sys/var/searchList", params);
  },

  /**
   * 保存
   * @param params
   */
  saveVar: (params) => {
    return request.post(serviceModule + "/sys/var/save", params);
  },

  /**
   * 删除
   * @param id
   */
  deleteVar: (id) => {
    return request.post(serviceModule + "/sys/var/delete?id=" + id);
  },
  /**
   * 调试
   * @param data
   */
  debugShellCmd: (data) => {
    return request.post(serviceModule + "/sys/var/debugShellCmd", data);
  },

}
